import { useQuery } from '@apollo/client';
import { GET_SESSION_USER_INFO } from '@/graphql/user/queries';
import type { GetUserResponse } from '@/generated/graphql';
import { getAccessToken } from '@/utils/tokenManager';

export const useGetUserSessionInfo = () => {
  // Use fetchPolicy: 'network-only' to prevent unnecessary network requests
  // and use nextFetchPolicy: 'network-only' to ensure we only use cached data after initial fetch
  const { data, loading, error } = useQuery<{ getSessionUserInfo: GetUserResponse }>(
    GET_SESSION_USER_INFO,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'network-only',
      // Skip the query if we don't have a token (user not logged in)
      skip: !getAccessToken(),
    }
  );
  const userInfo = data?.getSessionUserInfo;

  return { userInfo, loading, error };
};
